import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { NavigationService } from 'app/shared/services/data-services/navigation/navigation.service';
import { LogoutMessageComponent } from './logout-message/logout-message.component';
import { UserProfileService } from 'app/shared/user-profile/user-profile.service';
import { filter, takeUntil } from 'rxjs/operators';
import { UserPortfolioPreferencesService } from 'app/shared/services/user-preferences/user-portfolio-preferences.service';
import { IHeaderResponsivenessOptions } from 'app/shared/models/header-display-options';
import { TimezoneService } from 'app/shared/services/timezone/timezone.service';
import { environment } from 'environments/environment';

interface UserMenuOption {
  label: string;
  icon: string;
  action: () => void;
}

@Component({
  selector: 'app-user-box',
  templateUrl: './user-box.component.html',
  styleUrls: ['./user-box.component.scss'],
  standalone: false,
})
export class UserBoxComponent implements OnInit, OnDestroy {
  @Input() headerResponsivenessOptions: IHeaderResponsivenessOptions;

  public options = [];
  public firstName = '';
  public lastName = '';
  public userPosition: string = '';
  public dropdownOpen: boolean = false;
  public userLogo: string = '';
  private IMAGE_URL = environment.image_server + '/user';
  public logoError = false;
  public isDevMode = /localhost/.test(document.location.host);

  private destroy$ = new Subject<void>();

  constructor(
    private userProfileService: UserProfileService,
    private navigationService: NavigationService,
    private modalService: BsModalService,
    public timezoneService: TimezoneService,
    private userPortfolioPreferencesService: UserPortfolioPreferencesService,
  ) {}

  public ngOnInit(): void {
    this.setUserMenuOptions();
    if (environment.auth_enabled) {
      this.loadUserProfile();
      this.userPortfolioPreferencesService.profileUpdated$
        .pipe(takeUntil(this.destroy$))
        .subscribe(() => {
          this.loadUserProfile();
        });
    }
  }

  private loadUserProfile(): void {
    this.userProfileService
      .userProfileLoaded()
      .pipe(
        filter(v => v),
        takeUntil(this.destroy$)
      )
      .subscribe(() => {
        const userProfile = this.userProfileService.getUserProfile();
        this.firstName = userProfile.firstName || '';
        this.lastName = userProfile.lastName || '';
        if (!this.firstName && !this.lastName) {
          this.firstName = 'No Name';
        }
        this.userPosition = userProfile.position || '';
        this.userLogo = this.IMAGE_URL + '/' + userProfile.id + '.webp';
      });
  }

    private setUserMenuOptions(): void {
    this.options = [
      {
        label: 'HEADER.USER_PREFERENCES',
        icon: 'fa-cog',
        action: () => this.navigationService.navigateToModule('settings'),
      },
      {
        label: 'HEADER.LOGOUT',
        icon: 'fa-sign-out-alt',
        action: () => this.openLogoutModal(),
      },
    ];
  }

  public optionSelected(option: UserMenuOption): void {
    option.action();
  }

  private openLogoutModal(): void {
    const modalRef: BsModalRef = this.modalService.show(LogoutMessageComponent);
    modalRef.content.modalRef = modalRef;
    modalRef.setClass('custom_modal modal-dialog-centered modal-sm');
  }

  get collapsed(): boolean {
    return this.headerResponsivenessOptions?.collapseUserSettingsMenu ?? false;
    }

  public toggleDropdownOpen(event: boolean): void {
    this.dropdownOpen = event;
  }

  public onLogoError(): void {
    this.logoError = true;
  }

  public ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
